import React from 'react'
import uuid from 'react-uuid'

const defaultWidth = 40
const defaultHeight = 40

export default {
  wP: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.883 36.193v-2.758c.07-.484.296-.931.641-1.276 7.028-3.883 7.11-7.855 7.11-8.021v-1.655l-3.151.241h-.173a.875.875 0 01-.855-.724l-.11-.69a.87.87 0 01.69-1h.062l2.53-1.538-.344-.31a5.469 5.469 0 117.345 0l-.345.31 2.53 1.538h.063a.869.869 0 01.69 1l-.11.69a.876.876 0 01-.787.759h-.152l-3.158-.249v1.628c0 .165.082 4.138 7.11 8.027.345.346.57.793.641 1.276V36.2l-20.227-.007z'
          fill={`url(#${id})`}
        />
        <path
          d='M20 9.324a5.117 5.117 0 013.448 8.917l-.69.621.794.476L25.62 20.6l.11.069h.131a.524.524 0 01.428.6l-.11.69a.524.524 0 01-.518.434h-.145l-2.758-.214-.745-.055v2.014c0 .172.083 4.29 7.234 8.276.269.274.45.622.517 1v2.448H10.229v-2.414c.06-.389.238-.75.51-1.034 7.152-4.007 7.234-8.131 7.234-8.276V22.11l-.73.056-2.76.213h-.144a.524.524 0 01-.517-.434l-.11-.69a.524.524 0 01.427-.6h.131l.11-.069 2.07-1.262.792-.469-.69-.62A5.117 5.117 0 0120 9.317v.007zm0-.696a5.807 5.807 0 00-3.903 10.117l-2.07 1.262a1.214 1.214 0 00-.992 1.38l.068.682a1.214 1.214 0 001.194 1.014h.2l2.758-.214v1.269s0 3.876-6.98 7.752a2.71 2.71 0 00-.772 1.551v3.11h20.96v-3.103a2.704 2.704 0 00-.773-1.552c-6.98-3.882-6.98-7.758-6.98-7.758v-1.283l2.759.214h.2a1.214 1.214 0 001.228-1l.11-.69A1.214 1.214 0 0026.014 20l-2.07-1.262A5.807 5.807 0 0020 8.634v-.006z'
          fill='#231F20'
        />
        <defs>
          <linearGradient
            id={id}
            x1='9.883'
            y1='22.586'
            x2='30.117'
            y2='22.586'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#F7F5D2' />
            <stop offset='1' stopColor='#D7D4B7' />
          </linearGradient>
        </defs>
      </svg>
    )
  },
  wR: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M7.669 36.076v-3.262h2.793v-2.58l3.255-2.786V15.807l-3.724-2.324V7.22h4.193v2.793h3.717V7.22h4.194v2.793h3.717V7.22h4.193v6.262l-3.724 2.324v11.641l3.255 2.787v2.579h2.793v3.262H7.669z'
          fill={`url(#${id})`}
        />
        <path
          d='M30.007 32.352v-2.324l-3.255-2.759V16.062l3.724-2.324v-6.98h-5.124v2.76h-2.759v-2.76h-5.152v2.76h-2.758v-2.76H9.53v6.98l3.724 2.324v11.172L10 29.995v2.323H7.241v4.235H32.8v-4.2h-2.793zm-19.062-1.91h18.11v1.903h-18.13v-1.89l.02-.014zm-.483-22.76h3.255v2.76h4.655v-2.76h3.256v2.76h4.655v-2.76h3.255v4.6H10.462V7.684zm0 5.518h19.076l-3.283 2.069-.427.269H14.172l-.427-.269-3.283-2.069zm3.724 13.503V16.476h11.635V26.73l-11.635-.028zm-.324 1.207l.324-.276h11.635l.324.276 1.827 1.566H12.028l1.834-1.566zm18.007 7.697H8.131v-2.324h23.738v2.324z'
          fill='#231F20'
        />
        <defs>
          <linearGradient
            id={id}
            x1='7.669'
            y1='21.648'
            x2='32.331'
            y2='21.648'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#F7F5D2' />
            <stop offset='1' stopColor='#D7D4B7' />
          </linearGradient>
        </defs>
      </svg>
    )
  },
  wN: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12.29 36.152v-2.407s.096-2.241 4.055-5.759c4.345-3.862 3.4-6.38 3.358-6.483l-.179-.44-.4.261a16.6 16.6 0 01-5.434 2.27h-.124L12 25.193v.137c0 .138-.42 3.448-3.241 3.448h-.4a1.848 1.848 0 00-1.138-.503 1.559 1.559 0 00-1.014.393 4.504 4.504 0 01-2.573-1.807 3.91 3.91 0 01-.186-3.193c2.8-4.669 4.221-7.22 4.221-7.586 0-1.945.269-2.759.428-3.083a12.414 12.414 0 011.786-2.228l.11-.11V8.966a18.276 18.276 0 01-.572-4.235c.89.124 3.69 1.938 4.034 2.628l.345.69.345-.69c.241-.483 1.02-1.821 1.69-2.152.386 0 1.448 1.441 2.268 3.083l.118.227h.655c2.296 0 13.841.724 15.476 15.02 0 .077.883 7.587.924 12.6l-22.986.015z'
          fill={`url(#${id})`}
        />
        <path
          d='M9.759 5.283c1.027.434 3.048 1.786 3.317 2.29l.69 1.379.69-1.38a6.48 6.48 0 011.379-1.89 10.56 10.56 0 011.896 2.821l.2.463h.89a16.31 16.31 0 017.813 2.069c4.138 2.42 6.6 6.655 7.276 12.586 0 .076.835 7.158.918 12.165H12.683v-1.993s.138-2.124 3.93-5.517c4.47-3.973 3.58-6.628 3.45-6.897l-.353-.89-.793.532a16.123 16.123 0 01-5.283 2.207l-.248.041-.172.172-1.38 1.38-.193.193v.269c0 .124-.393 3.069-2.855 3.069h-.255a2.207 2.207 0 00-1.276-.442c-.384.003-.759.12-1.076.338a4.014 4.014 0 01-2.165-1.572 3.517 3.517 0 01-.193-2.841c4.248-7.083 4.248-7.525 4.248-7.76a7.055 7.055 0 01.386-2.91 11.607 11.607 0 011.67-2.13l.227-.228V8.883a26.344 26.344 0 01-.58-3.635l-.013.035zm-.449-.91a.276.276 0 00-.2.061c-.462.463.462 4.656.462 4.656v1.379c-.71.7-1.334 1.48-1.862 2.324a9.083 9.083 0 00-.462 3.255c0 .462-4.186 7.449-4.186 7.449-1.38 4.655 3.255 5.586 3.255 5.586a1.248 1.248 0 01.897-.414c.36.02.703.166.965.414.186.023.372.034.559.034 3.207 0 3.628-3.758 3.628-3.758l1.379-1.38a16.876 16.876 0 005.586-2.324s.931 2.324-3.255 6.048c-4.186 3.725-4.186 6.049-4.186 6.049v2.758h23.75c0-5.117-.93-13.027-.93-13.027C33.04 8.863 21.247 8.117 18.847 8.117h-.427s-1.649-3.29-2.621-3.29a.38.38 0 00-.172.042c-.931.462-1.863 2.324-1.863 2.324-.42-.848-3.551-2.855-4.455-2.855v.034z'
          fill='#231F20'
        />
        <path
          d='M20.283 15.6s.365 2.214-.538 3.352a1.484 1.484 0 00-.29 1.282c.07.262.18.483.366.483.462 0 1.379.462 1.379-5.117h-.917zM9.58 25.372s-.463 1.38-1.38 1.38c0 0 0 1.379.931.462s1.841-1.842.448-1.842zM5.855 23.51s-1.38 1.38.462 1.38l.931-.931s.47-1.849-1.393-.449zm6.98-11.172l-2.76 2.759s0 1.862.932.462h.234a1.158 1.158 0 002.07-.69 1.489 1.489 0 00-.463-1.166l.462-.462s1.387-.903-.476-.903z'
          fill='#231F20'
        />
        <defs>
          <linearGradient
            id={id}
            x1='3.193'
            y1='20.455'
            x2='35.248'
            y2='20.455'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#F7F5D2' />
            <stop offset='1' stopColor='#D7D4B7' />
          </linearGradient>
        </defs>
      </svg>
    )
  },

  wB: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M34.228 35.862a7.192 7.192 0 00-3.525-1.165 6.554 6.554 0 00-2.069.365 11.96 11.96 0 01-3.993.566c-3.282 0-3.71-2.759-3.73-2.856l-.056-.4h-1.724l-.055.4a3.51 3.51 0 01-3.724 2.856 11.96 11.96 0 01-3.993-.566 6.554 6.554 0 00-2.07-.365 7.192 7.192 0 00-3.517 1.165l-1.503-3.38a5.593 5.593 0 013.641-1.2 9.089 9.089 0 013.09.594 9.752 9.752 0 003.262.69c2.759 0 3.359-1.814 3.386-1.89l.18-.531-.552-.076a11.787 11.787 0 01-3.683-1.104l2.47-5.434h-.69a4.2 4.2 0 01-2.828-1.31c-.835-.959-1.138-2.373-.904-4.214.283-2.255 2.331-3.973 4.138-5.517 1.38-1.173 2.607-2.187 2.835-3.318l.09-.365-.221-.248a2.014 2.014 0 01-.793-1.573A2.22 2.22 0 0120 4.896a2.22 2.22 0 012.324 2.07 2.013 2.013 0 01-.793 1.572l-.228.18.097.434c.255 1.262 1.51 2.283 2.972 3.448 1.773 1.434 3.787 3.062 4 5.324.187 1.883-.158 3.324-1.02 4.283a4.062 4.062 0 01-2.71 1.255h-.69l2.455 5.503c-1.15.55-2.383.909-3.648 1.063l-.552.075.18.531c0 .076.689 1.89 3.385 1.89a9.752 9.752 0 003.263-.69 9.089 9.089 0 013.09-.593 5.593 5.593 0 013.64 1.2l-1.537 3.421z'
          fill={`url(#${id})`}
        />
        <path
          d='M22.352 16.993H20.69v-1.655a.69.69 0 00-1.38 0v1.655h-1.655a.69.69 0 00-.69.69v.048a.69.69 0 00.69.69h1.655v1.655a.69.69 0 001.38 0V18.42h1.655a.69.69 0 00.69-.69v-.048a.69.69 0 00-.683-.69z'
          fill='#231F20'
        />
        <path
          d='M32.09 30.8a9.49 9.49 0 00-3.249.62 9.18 9.18 0 01-3.103.642c-2.42 0-2.945-1.572-2.945-1.572s3.255-.462 4.186-1.38l-2.324-5.117s4.773 0 4.186-6.048c-.413-4.276-6.462-6.255-6.979-8.842 0-.055 0-.103-.034-.158a2.47 2.47 0 00.93-1.959A2.682 2.682 0 0020 4.428a2.683 2.683 0 00-2.759 2.558 2.469 2.469 0 00.966 1.938c0 .055 0 .104-.035.159-.462 2.324-6.455 4.655-6.979 8.841-.745 5.952 4.097 6.048 4.18 6.048l-2.325 5.11c.931.932 4.187 1.38 4.187 1.38s-.525 1.573-2.945 1.573a9.206 9.206 0 01-3.104-.642 9.495 9.495 0 00-3.248-.62 5.786 5.786 0 00-4.2 1.551l1.834 4.228a7.345 7.345 0 013.725-1.38c1.862 0 2.324.931 6.048.931s4.58-3.724 4.58-3.724 1.006 3.724 4.73 3.724 4.186-.93 6.048-.93a7.346 7.346 0 013.725 1.379l1.862-4.187a5.794 5.794 0 00-4.2-1.565zm-14.221-1.145l-.531-.076a13.44 13.44 0 01-3.145-.814 18.441 18.441 0 0111.572 0l-.186.076a17.705 17.705 0 01-7.71.814zm7.51-1.834a19.31 19.31 0 00-5.462-.787 18.684 18.684 0 00-5.283.745l1.552-3.448.193-.434a10.896 10.896 0 017.255.069l.166.365 1.58 3.49zM18.138 6.986A1.759 1.759 0 0120 5.36a1.759 1.759 0 011.862 1.627 1.552 1.552 0 01-.614 1.207l-.448.359a4.476 4.476 0 01-1.607 0l-.434-.345a1.552 1.552 0 01-.621-1.22zm-6.055 11.035c.262-2.07 2.234-3.731 3.98-5.187 1.454-1.22 2.703-2.268 2.978-3.544.342.063.688.095 1.035.096.297-.002.592-.035.883-.096.303 1.379 1.669 2.524 3.124 3.703 1.786 1.448 3.634 2.945 3.834 5.014.173 1.745-.13 3.062-.896 3.917a3.6 3.6 0 01-2.373 1.11h-1.42a11.168 11.168 0 00-6.703.02h-1.16a3.731 3.731 0 01-2.49-1.157c-.737-.862-1.006-2.16-.792-3.856v-.02zm3.262 17.151a11.545 11.545 0 01-3.855-.544 6.943 6.943 0 00-2.193-.387 7.237 7.237 0 00-3.304.931l-1.165-2.558a5.331 5.331 0 013.082-.89 8.628 8.628 0 012.931.566c1.101.427 2.268.66 3.449.69 3.055 0 3.8-2.118 3.827-2.208l.104-.31c.393.035.807.062 1.241.076l-.841 2.138c-.049.255-.483 2.496-3.276 2.496zm18.662 0a7.227 7.227 0 00-3.31-.972 6.95 6.95 0 00-2.194.386 11.542 11.542 0 01-3.855.545c-2.793 0-3.227-2.214-3.269-2.462l-.807-2.138c.393 0 .807-.041 1.228-.09l.11.325c0 .09.773 2.206 3.828 2.206a10.207 10.207 0 003.448-.69 8.629 8.629 0 012.904-.558 5.331 5.331 0 013.082.89l-1.165 2.558z'
          fill='#231F20'
        />
        <defs>
          <linearGradient
            id={id}
            x1='4.269'
            y1='20.372'
            x2='35.731'
            y2='20.372'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#F7F5D2' />
            <stop offset='1' stopColor='#D7D4B7' />
          </linearGradient>
        </defs>
      </svg>
    )
  },

  wQ: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M20 36.076c-6.648 0-10.938-.8-11.586-1.38l.048-.082 1.78-3.58-.545-3.8h-.29c-.166-.165-.828-1.069-1.517-5.193a378.923 378.923 0 00-1.47-8.248l6.084 8.276.427-12.014 4.407 11.897 2.566-12.828-.442-.103a2.324 2.324 0 111.062 0l-.441.103 2.565 12.828 4.407-11.897.442 12.014 6.082-8.276c-.351 1.848-.917 4.89-1.469 8.228-.69 4.138-1.379 5.027-1.517 5.193h-.29l-.544 3.82 1.813 3.635c-.634.607-4.924 1.407-11.572 1.407zm14.89-23.27a2.344 2.344 0 01-.6-.082l-.242-.062-.214-.11a2.324 2.324 0 111.056.255zm-29.78 0a2.331 2.331 0 111.056-.254l-.214.11-.242.062a2.33 2.33 0 01-.6.083zM26.641 9.87a2.324 2.324 0 11.89.145h-.462l-.428-.145zm-14.165.145a2.324 2.324 0 11.89-.145l-.428.159-.462-.014z'
          fill={`url(#${id})`}
        />
        <path
          d='M34.89 7.69a2.759 2.759 0 00-1.27 5.276l-5.71 7.724-.365-10.242a2.759 2.759 0 10-1.07-.172l-3.716 9.98-2.125-10.78a2.759 2.759 0 10-1.275 0l-2.118 10.78-3.717-9.953a2.793 2.793 0 10-1.069.173L12.09 20.69l-5.71-7.725a2.848 2.848 0 10-.552.207c.338 1.766.972 5.131 1.606 8.966.932 5.586 1.863 5.586 1.863 5.586l.462 3.255-1.718 3.449a.413.413 0 00-.144.29c0 1.027 5.413 1.861 12.096 1.861s12.097-.834 12.097-1.862a.416.416 0 00-.145-.29l-1.717-3.448.462-3.255s.93 0 1.862-5.586c.634-3.807 1.269-7.173 1.607-8.966a2.78 2.78 0 10.69-5.517l.04.035zM5.78 12.228l-.194.048a1.855 1.855 0 11.366-.138l-.173.09zM25.585 7.69a1.862 1.862 0 111.931 1.855h-.372L26.8 9.42a1.87 1.87 0 01-1.214-1.731zm-1.924 12.882l3.02-8.158.297 8.33.09 2.594a61.017 61.017 0 00-4.324-.297l.917-2.469zM18.145 6.78a1.862 1.862 0 112.29 1.814l-.428.097-.428-.097a1.855 1.855 0 01-1.441-1.834l.007.02zM20 11.034l1.883 9.4.517 2.594a81.158 81.158 0 00-4.8 0l.517-2.593 1.883-9.4zm-3.662 9.538l.903 2.47a60.73 60.73 0 00-4.324.296l.09-2.586.31-8.338 3.02 8.158zM10.69 7.69a1.862 1.862 0 112.51 1.744l-.345.125h-.372a1.855 1.855 0 01-1.793-1.87zm-3.45 8.04l4.083 5.517 1.531 2.07a19.544 19.544 0 00-4.083.82 36.496 36.496 0 01-.42-2.173c-.386-2.33-.766-4.51-1.097-6.24l-.014.006zm22.14 14.553a48.616 48.616 0 00-9.38-.766 48.66 48.66 0 00-9.393.759l-.317-2.241a43.48 43.48 0 019.71-.849c3.26-.081 6.52.203 9.717.849l-.338 2.248zM9.745 34.71c1.38-.455 4.827-1 10.255-1 5.428 0 8.848.552 10.255 1-1.641.428-5.083.897-10.255.897-5.172 0-8.614-.435-10.255-.897zm20.91-.834c-1.827-.648-5.91-1.104-10.662-1.104-4.752 0-8.834.456-10.655 1.104l1.255-2.504.083-.165A46.313 46.313 0 0120 30.448c3.126-.063 6.25.191 9.324.759l.083.165 1.248 2.504zm-.31-7.11h-.455l-.049.351A45.677 45.677 0 0020 26.255a45.777 45.777 0 00-9.848.862l-.049-.352h-.448a7.158 7.158 0 01-.69-1.737c1.221-.47 4.932-1.104 11.035-1.104s9.78.642 11.035 1.104a7.157 7.157 0 01-.69 1.738zm1.296-4.828a41.64 41.64 0 01-.42 2.172 19.496 19.496 0 00-4.097-.786l1.531-2.069 4.083-5.517c-.324 1.717-.703 3.89-1.09 6.22l-.007-.02zm3.242-9.62a1.872 1.872 0 01-.483-.07l-.193-.048-.172-.09a1.855 1.855 0 11.84.207h.008z'
          fill='#231F20'
        />
        <defs>
          <linearGradient
            id={id}
            x1='2.779'
            y1='20.255'
            x2='37.221'
            y2='20.255'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#F7F5D2' />
            <stop offset='1' stopColor='#D7D4B7' />
          </linearGradient>
        </defs>
      </svg>
    )
  },

  wK: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M20 36.076c-7.062 0-10.703-1.304-10.703-1.862v-.131c.42-1.683.42-1.842.42-4.524 0-3.042-3.262-4.731-3.4-4.828-1.724-1.062-2.607-3.076-2.607-6.11a7.207 7.207 0 0112.704-4.676l.986 1.158-.159-1.51a2.759 2.759 0 012.373-3.083l.4-.055V6.76v3.696l.4.055a2.8 2.8 0 012.393 2.759c.006.108.006.216 0 .324l-.166 1.504.98-1.152a7.207 7.207 0 119.241 10.827 6.152 6.152 0 00-2.593 4.787c0 2.682 0 2.841.42 4.524v.096c.014.593-3.627 1.897-10.689 1.897z'
          fill={`url(#${id})`}
        />
        <path
          d='M29.076 10.945a7.655 7.655 0 00-5.841 2.703 3.242 3.242 0 00-2.76-3.593V7.228h2.284V6.29h-2.297V3.966h-.924V6.29H17.24v.93h2.325v2.828a3.242 3.242 0 00-2.76 3.593 7.676 7.676 0 00-13.558 4.98c0 2.758.69 5.2 2.904 6.545 0 0 3.145 1.6 3.145 4.386 0 2.662 0 2.758-.407 4.413a.538.538 0 00-.062.242c.006 1.29 5.007 2.345 11.172 2.345 6.166 0 11.166-1.042 11.166-2.324a.538.538 0 00-.063-.242c-.407-1.62-.407-1.745-.407-4.414a5.723 5.723 0 012.407-4.4 7.676 7.676 0 00-4-14.227h-.027zm-9.407 0l.331-.049.331.049a2.31 2.31 0 011.98 2.565l-.16 1.38A7.249 7.249 0 0020 18.152a7.25 7.25 0 00-2.152-3.242l-.158-1.379a2.31 2.31 0 011.979-2.566v-.02zM10.228 30.49c1.227-.552 4.558-1.276 9.793-1.276 5.234 0 8.496.69 9.751 1.262-.023.781.018 1.563.125 2.338-1.862-.745-5.58-1.248-9.883-1.248-4.304 0-8.076.517-9.924 1.268.112-.776.158-1.56.138-2.344zm19.551-1c-1.896-.69-5.517-1.207-9.758-1.207-4.242 0-7.91.496-9.793 1.22a4.746 4.746 0 00-.497-2.069h.103c.732-.538 4.221-1.49 10.166-1.49s9.407.953 10.18 1.477a5.806 5.806 0 00-.4 2.069zM6.614 24.359c-1.642-1.014-2.435-2.89-2.435-5.738a6.744 6.744 0 0111.883-4.373l1.945 2.304a6.076 6.076 0 011.303 3.82v4.649c-4.827.062-8.8.758-10.055 1.69a8.192 8.192 0 00-2.641-2.352zM20 35.607c-5.959 0-9.455-.938-10.186-1.497l.034-.138c.759-.558 4.242-1.482 10.173-1.482 5.93 0 9.29.89 10.124 1.455l.041.172c-.73.559-4.227 1.49-10.186 1.49zm12.586-11.228a7.124 7.124 0 00-1.972 2.2c-1.428-.876-5.29-1.517-9.924-1.572v-4.635a6.096 6.096 0 011.379-3.882l1.91-2.242a6.744 6.744 0 118.607 10.131z'
          fill='#231F20'
        />
        <defs>
          <linearGradient
            id={id}
            x1='3.71'
            y1='20.255'
            x2='36.29'
            y2='20.255'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#F7F5D2' />
            <stop offset='1' stopColor='#D7D4B7' />
          </linearGradient>
        </defs>
      </svg>
    )
  },

  bP: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          stroke='#D4D1B4'
          d='M29.655 31.89c-6.945-3.862-6.945-7.752-6.945-7.752v-1.262l2.759.214a1.214 1.214 0 001.38-.993l.11-.69a1.214 1.214 0 00-.994-1.38l-2.068-1.262a5.8 5.8 0 10-7.793 0l-2.07 1.263a1.214 1.214 0 00-.993 1.379l.11.69a1.214 1.214 0 001.38.993l2.759-.214v1.262s0 3.869-6.966 7.738c-.42.416-.69.96-.772 1.545v3.13h20.896v-3.11a2.704 2.704 0 00-.793-1.551z'
          fill={`url(#${id})`}
        />
        <defs>
          <linearGradient
            id={id}
            x1='9.552'
            y1='22.607'
            x2='30.448'
            y2='22.607'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#3A3A3F' />
            <stop offset='1' stopColor='#040408' />
          </linearGradient>
        </defs>
      </svg>
    )
  },
  bR: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          stroke='#D4D1B4'
          d='M30.007 32.345V30.02l-3.255-2.793V16.055l3.724-2.33v-6.98h-5.124v2.793h-2.793V6.745H17.44v2.793h-2.793V6.745H9.524v6.979l3.724 2.331v11.173L9.993 30.02v2.324H7.2v4.193h25.6v-4.193h-2.793z'
          fill={`url(#${id})`}
        />
        <path
          d='M28.607 30.952h-17.22v1.393h17.22v-1.393zm-3.255-15.366H14.648v1.393h10.704v-1.393zm3.724-3.724H10.924v1.393h18.152v-1.393zM12.786 29.09h14.428l-1.862-1.4H14.648l-1.862 1.4z'
          fill='#D4D1B4'
        />
        <defs>
          <linearGradient
            id={id}
            x1='7.2'
            y1='21.641'
            x2='32.8'
            y2='21.641'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#3A3A3F' />
            <stop offset='1' stopColor='#040408' />
          </linearGradient>
        </defs>
      </svg>
    )
  },
  bN: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          stroke='#D4D1B4'
          d='M3.841 23.503s4.187-6.951 4.187-7.448A9.09 9.09 0 018.49 12.8a12.732 12.732 0 011.855-2.331v-1.38s-.931-4.186-.462-4.655c.469-.468 4.186 1.863 4.655 2.76 0 0 .931-1.863 1.862-2.325.931-.462 2.759 3.255 2.759 3.255s14.427-.93 16.29 15.359c0 0 .93 7.91.93 13.034H12.683V33.76s0-2.325 4.186-6.049 3.255-6.048 3.255-6.048a16.876 16.876 0 01-5.586 2.324l-1.38 1.38s-.461 4.186-4.186 3.724a1.288 1.288 0 00-1.862 0s-4.669-.931-3.269-5.587z'
          fill={`url(#${id})`}
        />
        <path
          d='M19.662 9.538l.462 1.38s10.704-1.38 11.635 15.827v8.862h2.324v-8.848S34.097 10 19.663 9.538zm1.4 6.048s.366 2.214-.538 3.359a1.484 1.484 0 00-.296 1.283c.069.262.179.482.365.482.462 0 1.38.462 1.38-5.117l-.91-.007zm-10.717 9.78s-.462 1.379-1.38 1.379c0 0 0 1.38.932.462.93-.917 1.827-1.841.448-1.841zm-3.711-1.863s-1.379 1.38.463 1.38l.93-.931s.47-1.849-1.393-.449zm6.98-11.172l-2.759 2.759s0 1.862.931.462h.242a1.158 1.158 0 002.069-.69 1.489 1.489 0 00-.463-1.165l.463-.462s1.379-.904-.483-.904z'
          fill='#D4D1B4'
        />
        <defs>
          <linearGradient
            id={id}
            x1='3.579'
            y1='20.448'
            x2='36.421'
            y2='20.448'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#3A3A3F' />
            <stop offset='1' stopColor='#040408' />
          </linearGradient>
        </defs>
      </svg>
    )
  },

  bB: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          stroke='#D4D1B4'
          d='M28.841 31.414c-5.117 1.862-6.082-.931-6.082-.931s3.255-.462 4.186-1.38l-2.324-5.117s4.772 0 4.186-6.048c-.414-4.276-6.462-6.255-6.98-8.841 0-.056 0-.104-.034-.16a2.47 2.47 0 00.966-1.958A2.683 2.683 0 0020 4.414a2.683 2.683 0 00-2.759 2.558 2.469 2.469 0 00.966 1.938c0 .056 0 .104-.035.159-.496 2.331-6.49 4.655-7.013 8.862-.752 6.007 4.186 6.048 4.186 6.048l-2.324 5.118c.93.93 4.186 1.379 4.186 1.379s-.931 2.758-6.048.93c-4.993-1.806-7.449.939-7.449.939l1.862 4.207a7.345 7.345 0 013.725-1.38c1.862 0 2.324.931 6.048.931a3.98 3.98 0 004.186-3.255h.931a3.98 3.98 0 004.186 3.255c3.724 0 4.186-.93 6.049-.93a7.346 7.346 0 013.724 1.379l1.862-4.187s-2.449-2.765-7.442-.951z'
          fill={`url(#${id})`}
        />
        <path
          d='M22.352 16.986H20.69v-1.655a.69.69 0 00-1.38 0v1.655h-1.655a.69.69 0 00-.69.69v.048a.69.69 0 00.69.69h1.655v1.655a.69.69 0 001.38 0v-1.655h1.655a.69.69 0 00.69-.69v-.069a.69.69 0 00-.683-.669zm-6.538 8.38l.93-1.435a12.945 12.945 0 016.518 0l.931 1.434a21.022 21.022 0 00-8.38 0zm-1.4 3.254l.758-1.723s5.276-1.173 9.621 0l.793 1.724s-4.345-1.724-11.172 0z'
          fill='#D8D5B6'
        />
        <defs>
          <linearGradient
            id={id}
            x1='3.71'
            y1='20.476'
            x2='36.29'
            y2='20.476'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#3A3A3F' />
            <stop offset='1' stopColor='#040408' />
          </linearGradient>
        </defs>
      </svg>
    )
  },

  bQ: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          stroke='#D4D1B4'
          d='M34.897 7.676a2.758 2.758 0 00-1.27 5.276L27.91 20.69l-.365-10.249a2.759 2.759 0 10-1.07-.172l-3.716 9.972-2.125-10.779a2.759 2.759 0 10-1.275 0l-2.118 10.78-3.717-9.952a2.794 2.794 0 10-1.069.172L12.09 20.69l-5.718-7.738a2.848 2.848 0 10-.551.207c.338 1.765.972 5.138 1.607 8.965.93 5.586 1.862 5.586 1.862 5.586l.462 3.255-1.718 3.449a.414.414 0 00-.144.29c0 1.027 5.42 1.861 12.103 1.861s12.104-.834 12.104-1.862a.416.416 0 00-.145-.29l-1.718-3.447.462-3.256s.932 0 1.863-5.586c.634-3.807 1.269-7.18 1.607-8.965a2.78 2.78 0 10.69-5.518l.04.035z'
          fill={`url(#${id})`}
        />
        <path
          d='M30.876 34.297l-.31-.09a37.688 37.688 0 00-10.345-1.38A37.31 37.31 0 009.379 34.36l-.338.11.69-1.428.31-.09a38.872 38.872 0 0110.173-1.303 39.39 39.39 0 019.655 1.159l.303.076.704 1.414zm-1.407-4.532l-.152 1.056v.096l-.227-.048a45.222 45.222 0 00-8.842-.855 44.828 44.828 0 00-9.31.951l-.228.049v-.193l-.138-.966.228-.048a45.937 45.937 0 019.462-.952 46.208 46.208 0 018.98.862l.227.049zm.221-2.751l.165.034-.076.51-.09.649-.158-.035a44.936 44.936 0 00-9.303-.944 44.773 44.773 0 00-9.745 1.048h-.138l-.131-.69-.062-.414.165-.034a45.879 45.879 0 019.91-1.048 46.255 46.255 0 019.463.924z'
          fill='#D4D1B4'
        />
        <defs>
          <linearGradient
            id={id}
            x1='2.31'
            y1='20.241'
            x2='37.69'
            y2='20.241'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#3A3A3F' />
            <stop offset='1' stopColor='#040408' />
          </linearGradient>
        </defs>
      </svg>
    )
  },

  bK: ({ width = defaultWidth, height = defaultHeight, id = uuid() } = {}) => {
    return (
      <svg
        version='1.1'
        width={width}
        height={height}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          stroke='#D4D1B4'
          d='M36.759 18.62a7.675 7.675 0 00-13.524-4.979 3.242 3.242 0 00-2.76-3.593V7.221h2.284v-.945h-2.297V3.952h-.924v2.324H17.24v.93h2.325v2.828a3.241 3.241 0 00-2.76 3.594 7.676 7.676 0 10-9.91 11.538 5.71 5.71 0 012.38 4.386c0 2.662 0 2.758-.407 4.413a.545.545 0 00-.062.242c.02 1.283 5.02 2.345 11.193 2.345 6.172 0 11.172-1.042 11.172-2.324a.544.544 0 00-.062-.242c-.407-1.62-.407-1.745-.407-4.414a5.711 5.711 0 012.4-4.406 7.668 7.668 0 003.656-6.545z'
          fill={`url(#${id})`}
        />
        <path
          d='M20 12.31a.945.945 0 01.945.938c-.21.877-.528 1.725-.945 2.524a11.306 11.306 0 01-.952-2.51.952.952 0 01.952-.952zm0-1.379a2.324 2.324 0 00-2.324 2.324c0 1.283 2.324 5.586 2.324 5.586s2.324-4.303 2.324-5.586A2.324 2.324 0 0020 10.931zm-9.503 2.779c4.062 0 5.517 2.759 5.91 3.924.195.521.425 1.028.69 1.518.462.869 1.034 1.951 1.006 2.724v2.4c-.51-.041-1.11-.076-1.779-.076a16.91 16.91 0 00-5.986 1.007c-1.717-1.22-4.752-3.91-4.793-6.517.048-.531.572-4.98 4.903-4.98h.049zm-.049-1.379c-5.8 0-6.234 6.29-6.234 6.29 0 4.358 6.014 8.117 6.014 8.117a15.305 15.305 0 016.144-1.186 17.23 17.23 0 013.166.269V21.89c.048-1.676-1.38-3.531-1.814-4.745-.634-1.766-2.545-4.828-7.207-4.828l-.069.014zm18.869 1.359a4.751 4.751 0 013.828 1.703 5.517 5.517 0 011.2 3.917c-.407 2.249-2.759 4.828-4.717 5.918l-.476-.173a16.654 16.654 0 00-4.324-.82c-.449 0-.89-.042-1.325-.042-.572 0-1.137 0-1.682.07v-2.394c0-.966.593-2.131 1.193-3.255.241-.455.496-.931.69-1.38a5.918 5.918 0 012.068-2.503 6.415 6.415 0 013.49-1.034l.055-.007zm-.055-1.373a7.752 7.752 0 00-4.255 1.27 7.303 7.303 0 00-2.559 3.082c-.69 1.6-2.069 3.448-2.02 5.255v3.931c1.012-.187 2.04-.28 3.069-.276.413 0 .827 0 1.24.042a15.19 15.19 0 013.946.738c.301.142.618.248.945.317.193-.018.38-.082.544-.186 2.387-1.255 5.021-4.27 5.518-6.931a6.82 6.82 0 00-1.462-4.994 6.077 6.077 0 00-4.925-2.24l-.04-.008zm.924 21.793a37.78 37.78 0 00-10.034-1.31 37.739 37.739 0 00-10.228 1.38l-.103-.063c.124-.482.207-.848.262-1.186a38.923 38.923 0 0110.055-1.283 39.39 39.39 0 019.655 1.159l.138.034c.041.366.131.752.255 1.27zm-.414-5.02v1.2a38.079 38.079 0 00-9.655-1.2 37.771 37.771 0 00-9.896 1.255v-1.207a38.993 38.993 0 019.93-1.242 39.395 39.395 0 019.656 1.16l-.035.034z'
          fill='#D4D1B4'
        />
        <defs>
          <linearGradient
            id={id}
            x1='3.241'
            y1='20.241'
            x2='36.759'
            y2='20.241'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#3A3A3F' />
            <stop offset='1' stopColor='#040408' />
          </linearGradient>
        </defs>
      </svg>
    )
  }
}
